// frontend2/src/utils/maskVpa.js

/**
 * Mask VPA / UPI ID for non-Level 1 users (Levels 2-5).
 * - Level 1 (Super Admin): returns full unmasked VPA string.
 * - Levels 2-5: keeps first 4 characters, replaces remaining characters with '#'
 *
 * Example:
 * maskVpa('7890789078-1@upi', 2) => '7890############'
 * maskVpa('9876543210@ybl', 1)  => '9876543210@ybl'
 */
export const maskVpa = (vpa, userLevel) => {
  if (!vpa || typeof vpa !== 'string') return vpa || '';
  
  // Level 1 Super Admin sees full unmasked VPA
  if (Number(userLevel) === 1) {
    return vpa;
  }

  // Level 2 to 5: Keep first 4 digits/chars, replace the rest with '#'
  if (vpa.length <= 4) {
    return vpa;
  }

  const visiblePart = vpa.slice(0, 4);
  const maskedPart = '#'.repeat(vpa.length - 4);
  return `${visiblePart}${maskedPart}`;
};

/**
 * Helper to get user level from session storage token safely
 */
export const getUserLevelFromToken = () => {
  try {
    const token = sessionStorage.getItem('token');
    if (!token) return null;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const decoded = JSON.parse(jsonPayload);
    return decoded.level !== undefined ? Number(decoded.level) : null;
  } catch (err) {
    return null;
  }
};
